import { lazy, type ComponentType } from "react";
import Home from "@/pages/Home";
import MyAgents from "@/pages/MyAgents";
// import Market from "@/pages/Market";
import CustodyTrading from "@/pages/CustodyTrading";
import Team from "@/pages/Team";
import { ComingSoonOverlay } from "@/components/ComingSoonOverlay";
import Profile from "@/pages/Profile";
import NotFound from "@/pages/NotFound";
import Market from "@/pages/Market";

export type RouteMeta = {
  showHeader: boolean;
  showBottomNav: boolean;
  requiresAuth: boolean;
};

export type RouteItem = {
  path: string;
  element: ComponentType;
  meta: RouteMeta;
};

function withComingSoon(Page: ComponentType) {
  const Wrapped = () => (
    <ComingSoonOverlay>
      <Page />
    </ComingSoonOverlay>
  );
  Wrapped.displayName = `ComingSoon(${Page.displayName ?? Page.name ?? "Page"})`;
  return Wrapped;
}

/**
 * 路由表：新增页面加一行即可
 * meta 里 showHeader / showBottomNav / requiresAuth 三个字段控制布局与鉴权
 */
export const routes: RouteItem[] = [
  {
    path: "/login",
    element: lazy(() => import("@/pages/Login")) as ComponentType,
    meta: { showHeader: false, showBottomNav: false, requiresAuth: false },
  },
  {
    path: "/set-password",
    element: lazy(() => import("@/pages/SetPassword")) as ComponentType,
    meta: { showHeader: false, showBottomNav: false, requiresAuth: false },
  },
  {
    path: "/",
    element: lazy(() => import("@/pages/Home")) as ComponentType,
    meta: { showHeader: true, showBottomNav: true, requiresAuth: false },
  },
  {
    path: "/my-agents",
    element: lazy(() => import("@/pages/MyAgents")) as ComponentType,
    meta: { showHeader: true, showBottomNav: true, requiresAuth: false },
  },
  {
    path: "/market",
    element: Market,
    meta: { showHeader: true, showBottomNav: true, requiresAuth: false },
  },
  {
    path: "/ai-trading",
    element: lazy(() => import("@/pages/AiTradingV2")) as ComponentType,
    meta: { showHeader: true, showBottomNav: true, requiresAuth: false },
  },
  {
    path: "/custody",
    element: lazy(() => import("@/pages/CustodyTrading")) as ComponentType,
    meta: { showHeader: true, showBottomNav: true, requiresAuth: false },
  },
  {
    path: "/team",
    // element: withComingSoon(Team),
    element: lazy(() => import("@/pages/Team")) as ComponentType,
    meta: { showHeader: true, showBottomNav: true, requiresAuth: true },
  },
  {
    path: "/profile",
    element: lazy(() => import("@/pages/Profile")) as ComponentType,
    meta: { showHeader: true, showBottomNav: true, requiresAuth: true },
  },
  {
    path: "/announcements",
    element: lazy(() => import("@/pages/AnnouncementList")) as ComponentType,
    meta: { showHeader: true, showBottomNav: true, requiresAuth: false },
  },
  {
    path: "/announcement/:id",
    element: lazy(() => import("@/pages/AnnouncementDetail")) as ComponentType,
    meta: { showHeader: true, showBottomNav: true, requiresAuth: false },
  },
  {
    path: "/404",
    element: lazy(() => import("@/pages/NotFound")) as ComponentType,
    meta: { showHeader: true, showBottomNav: true, requiresAuth: false },
  },
];
